<template>
  <div class="title">
    {{ title }}
  </div>
</template>
<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
export default {
  setup() {
    const route = useRoute();
    const title = computed(() => {
      return route.name;
    });

    return {
      title,
    };
  },
};
</script>

<style lang="less" scoped>
.title{font-weight:bold;}
</style>
